import { render, staticRenderFns } from "./PDEntityBox.vue?vue&type=template&id=47da373c&scoped=true"
import script from "./PDEntityBox.vue?vue&type=script&lang=js"
export * from "./PDEntityBox.vue?vue&type=script&lang=js"
import style0 from "./PDEntityBox.vue?vue&type=style&index=0&id=47da373c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da373c",
  null
  
)

export default component.exports